import { Link } from 'react-router-dom';

export default function HeroSection() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '韩国漫画网',
    url: 'https://koreanmanhwa.com',
    description: '韩国漫画网提供免费的韩漫在线观看和下拉式韩漫大全阅读，提供便捷访问方式，让您随时随地沉浸于多样漫画世界无需成本。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://koreanmanhwa.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20illustration%20of%20a%20magical%20Korean%20manhwa%20reading%20environment%2C%20floating%20comic%20panels%20with%20dynamic%20action%20scenes%20and%20romance%20illustrations%20in%20soft%20watercolor%20style%2C%20warm%20golden%20and%20deep%20crimson%20ambient%20glow%2C%20ethereal%20particles%20drifting%2C%20traditional%20Korean%20ink%20painting%20elements%20blending%20with%20modern%20digital%20art%2C%20dreamy%20atmosphere%2C%20cinematic%20wide%20composition%2C%20artistic%20and%20abstract%2C%20warm%20color%20palette%20dominated%20by%20amber%20and%20soft%20coral%20tones&width=1920&height=1080&seq=hero-bg-manhwa&orientation=landscape"
          alt="韩国漫画网 - 韩漫在线观看"
          className="w-full h-full object-cover object-top"
          title="韩国漫画网 - 免费韩漫阅读平台"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/55"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4">
        <div className="w-full max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 mb-6">
            <i className="ri-fire-line text-accent-500 text-sm"></i>
            <span className="text-xs text-white/90">每日更新 · 海量韩漫 · 完全免费</span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
            韩国漫画网
            <span className="block text-2xl md:text-3xl lg:text-4xl font-normal mt-2 text-white/90">
              韩漫在线观看平台
            </span>
          </h1>

          <p className="text-sm md:text-base text-white/70 mb-8 max-w-xl mx-auto leading-relaxed">
            在韩国漫画网，体验免费的韩漫在线观看和下拉式韩漫大全阅读，提供便捷访问方式，让您随时随地沉浸于多样漫画世界无需成本。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/all"
              className="px-8 py-3 bg-primary-500 text-white font-medium rounded-full hover:bg-primary-600 transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer text-sm"
            >
              立即阅读
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/category/recommended"
              className="px-8 py-3 bg-white/10 backdrop-blur-sm text-white font-medium rounded-full border border-white/20 hover:bg-white/20 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
            >
              热门推荐
            </Link>
          </div>

          <div className="flex items-center justify-center gap-6 mt-8">
            <div className="text-center">
              <p className="text-xl md:text-2xl font-bold text-white">500+</p>
              <p className="text-[11px] text-white/50 mt-0.5">漫画作品</p>
            </div>
            <div className="w-px h-8 bg-white/20"></div>
            <div className="text-center">
              <p className="text-xl md:text-2xl font-bold text-white">50万+</p>
              <p className="text-[11px] text-white/50 mt-0.5">活跃读者</p>
            </div>
            <div className="w-px h-8 bg-white/20"></div>
            <div className="text-center">
              <p className="text-xl md:text-2xl font-bold text-white">每日更新</p>
              <p className="text-[11px] text-white/50 mt-0.5">精彩不断</p>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-white/60 text-2xl"></i>
      </div>
    </section>
  );
}